import React from 'react';

const SectionJustifyFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fill="#010101"
            d="M4 20h16v-4H4v4zM4 10v4h16v-4H4zM4 4v4h16V4H4z"
        />
    </svg>
);

SectionJustifyFillSvg.displayName = 'SectionJustifyFillSvg';
export default SectionJustifyFillSvg;
